import { render, staticRenderFns } from "./CalendarRules.vue?vue&type=template&id=558d057a&scoped=true"
import script from "./CalendarRules.vue?vue&type=script&lang=js"
export * from "./CalendarRules.vue?vue&type=script&lang=js"
import style0 from "./CalendarRules.vue?vue&type=style&index=0&id=558d057a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d057a",
  null
  
)

export default component.exports